import { defineStore } from 'pinia';
import contractnet from '@/network/contractnet';
import { useContractStore } from './contract';
import { usePaymentScheduleStore } from './paymentSchedule';
import validation from '@/assets/js/validation';

export const useContractDraftStore = defineStore('contractdraft', {
  state: () => {
    return {
      // 草编合同
      ContractDrafts: [],
      // 草案媒体信息
      ContractDraftMedias: [],
      // 付款明细
      ContractDraftPaymentDetails: [],
      // 当前正在编辑第几个草编合同
      EditIndex: -1,
      index: 0,
      isUrgent: false,
      bRevise: false,
      //Billing Address
      BillNameOptionals: [],
      clientAccountContacList: [],
      SignByList: [],
    };
  },
  getters: {},
  actions: {
    // 刷新
    async RefreshContractDraft() {
      const useContract = useContractStore();
      const ContractId = useContract.Id;
      //this.editDraftMediaId = useContract.disabled ? -1 : 0;

      const res = await contractnet
        .GetDraftContractInfo(ContractId)
        .then((res) => res);

      // 草案合同信息
      this.ContractDrafts = res.data.contractDrafts;
      this.BillNameOptionals = res.data.billNameOptionals;
      this.clientAccountContacList = res.data.clientAccountContacList;

      this.setSignByList(res.data.signByList);
      // this.EditIndex = -1
      // if (this.ContractDrafts.length === 1) {
      //   if (!useContract.disabled) {
      //     this.EditIndex = 0
      //   }
      // }

      // 草案媒体信息
      this.ContractDraftMedias = res.data.contractDraftMedias;
      if (this.ContractDraftMedias && this.ContractDraftMedias.length > 0) {
        this.ContractDraftMedias = this.ContractDraftMedias.sort((a, b) => {
          var a1 = 0;
          var b1 = 0;
          if (a.productionCostInfo) {
            a1 = JSON.parse(a.productionCostInfo)?.sort ?? 0;
          }
          if (b.productionCostInfo) {
            b1 = JSON.parse(b.productionCostInfo)?.sort ?? 0;
          }
          return a1 - b1;
        });
      }

      this.ContractDraftPaymentDetails = res.data.paymentDetails;
    },
    async toSave(Action) {
      const message = await this.SaveData(Action).then((msg) => msg);
      return message;
    },
    /**
     * 保存数据
     * @returns
     */
    async SaveData(Action) {
      var message = '';

      // 如果不是正在编辑中的Draft Contract不保存

      var RequestContractDraft =
        this.ContractDrafts.filter((t) => t.isUpdate) || [];

      const contractDraftRules =
        require('@/views/contract/js/contractDraftRules').contractDraft;
      var source = RequestContractDraft;

      for (var i = 0; i < source.length; i++) {
        var ele = source[i];
        ele.validate = await validation
          .validate(ele, contractDraftRules)
          .then((err) => err);
      }

      if (source.filter((t) => (t?.validate?.length || 0) > 0).length > 0) {
        return source[0].validate[0].message;
      }

      var RequestContractDraftMedia = [];
      if (RequestContractDraft.length > 0) {
        RequestContractDraftMedia =
          this.ContractDraftMedias.filter(
            (t) =>
              RequestContractDraft.map((a) => a.id).indexOf(
                t.contractDraftId
              ) >= 0
          ) || [];
      }

      const RequestContractParam = {
        RequestContractDraft,
        RequestContractDraftMedia,
        isUrgent: this.isUrgent,
        Action,
      };

      const useContract = useContractDraftStore();

      if (useContract.Status === 'Issued') {
        if ((RequestContractDraft.signedContractFile || []).length === 0) {
          return 'Please upload "Signed Contract" before submit.';
        }
      }

      const res = await contractnet
        .SaveDraftContract(RequestContractParam)
        .then((res) => res);
      message = res.data?.resultMessage || '';

      return message;
    },
    /**
     * 更换账单
     */
    changeBillName(index, billingAddressId) {
      const dataInfo =
        this.BillNameOptionals?.find((t) => t.id === billingAddressId) || null;

      this.ContractDrafts[index].billingAddressName = dataInfo?.value || '';
      this.ContractDrafts[index].billingAddress =
        (dataInfo?.address1 || '') +
        '\r\n' +
        (dataInfo?.address2 || '') +
        '\r\n' +
        (dataInfo?.address3 || '');
    },
    /**
     * 修改保存ContractBillingAddress
     */
    async SaveContractBillingAddress(data) {
      const res = await contractnet
        .SaveContractBillingAddress(data)
        .then((res) => res);
      var result = res.data?.data || '';
      if (result) {
        data.billingUpdateByName = result.billingUpdateByName;
        data.billingUpdateDate = result.billingUpdateDate;
      }
      return result;
    },
    /**
     * 修改保存CombinedContractRequired
     */
    async SaveCombinedContractRequired(data) {
      const res = await contractnet
        .SaveCombinedContractRequired(data)
        .then((res) => res);
      var result = res.data?.data || '';
      const useContract = useContractStore();
      useContract.ContractSummary.updateByName = result.updateByName;
      useContract.ContractSummary.updateDate = result.updateDate;
      // if (result) {
      //   data.updateByName = result.updateByName;
      //   data.updateDate = result.updateDate;
      // }
      return result;
    },
    /**
     * Draft Contract Media明细
     * @returns
     */
    getContractDraftMedias() {
      return [...this.ContractDraftMedias];
    },
    setSignByList(value) {
      this.SignByList = value;
    },
    getSignByList() {
      return [...this.SignByList];
    },
    
    /**
* 检查付款计划的最小和最大日期是否与活动期间一致
* 此函数用于验证在多个付款计划中，最早的开始日期和最晚的结束日期是否与活动的开始和结束日期相同
* @returns {Promise<boolean>} 返回一个布尔值，表示日期是否匹配
*/
    MinMaxDatePaymentSchedule() {
      try {
        //修改media日期后,Internal Split/PaymentSchedule页面保存是否需要跟着修改
        if (!useContractStore().otherData.enableMinMaxMediaDate) {
          return true;
        }
        // 提取所有日期
        const dates = this.ContractDraftMedias.map(item => {
          const [startDateStr, endDateStr] = item.period.split(" - ");
          return [new Date(startDateStr.split("/").reverse().join("-")), new Date(endDateStr.split("/").reverse().join("-"))];
        }).flat();
        // 获取最小日期
        const campaignStart = this.formatDate(new Date(Math.min(...dates)));
        // 获取最大日期
        const campaignEnd = this.formatDate(new Date(Math.max(...dates)));
        for (let i = 0; i < this.ContractDraftPaymentDetails.length; i++) {
          const start = this.formatDate(this.ContractDraftPaymentDetails[i].campaignPeriodStart);
          const end = this.formatDate(this.ContractDraftPaymentDetails[i].campaignPeriodEnd);
          console.log("6666", start, end, campaignStart, campaignEnd);
          // 检查最小和最大日期是否与活动期间一致
          if (campaignStart !== start || campaignEnd !== end) {
            return false;
          }

        }
        return true;
      } catch (error) {
        console.error('Error in MinMaxDatePaymentSchedule:', error);
        return true;
      }
    },
    // 手动格式化日期，避免时区问题
    formatDate(date) {
      let parsedDate;
      // 尝试将date转换为日期对象
      if (date instanceof Date) {
        // 如果date已经是Date对象，直接使用
        parsedDate = date;
      } else if (typeof date === 'string') {
        // 尝试将字符串解析为Date对象
        parsedDate = new Date(date);
      }
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
      const day = String(parsedDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
});
